module.exports = __webpack_public_path__ + "img/payment_mobile.5ae3f67e.png";